import { get } from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { arrayToClass, randomId } from '../../../utilities/helper-fuctions';
import { RequestManager } from '../../../utilities/request';
import { LandingLayout } from '../../../layouts/landing/landing.layout';
import { ToastMessages } from '../../notifications/toast-messages';
import { Spinner } from '../../ui-components/spinner/spinner';
import { StatusMarker } from '../../ui-components/statusmarker/status-marker';

const mapStateProps = (store: any) => ({
    user: store.user.user,
});

const mapDispatchProps = () => ({});

class MyPendingContributionsComponent extends React.Component<any, any> {
    public state: any = {
        loading: false,
        contributions: [],
    };

    public componentDidMount() {
        this.fetchContributions();
    }

    public async fetchContributions(): Promise<void> {
        const userAid = get(this.props, 'user.aid');

        if (!userAid) {
            return;
        }

        this.setState({ loading: true });

        try {
            const response = await RequestManager.get(
                `/users/${userAid}/contributions`,
                { status: 'PENDING', page: 0, size: 50 }
            );

            if (!response) {
                throw new Error('Failed to load contributions');
            }

            this.setState({
                contributions: get(response, 'content') || [],
                loading: false,
            });
        } catch (err) {
            this.setState({ loading: false });
            toast.error(<ToastMessages error={err} />, { theme: 'light' });
        }
    }

    public render(): React.ReactElement {
        return (
            <div className='w-100 display-flex justify-content-center p-4'>
                <div className='w-100 palette--bgc-neutral-1 border-radius-1 elevation-1' style={{ maxWidth: '1200px' }}>
                    <div className='p-4 border-bottom-1 palette--bc-neutral-3'>
                        <h2 className='palette--c-neutral-6 m-0'>My Pending Contributions</h2>
                    </div>
                    <div className='p-4'>
                        {this.state.loading ? <Spinner size='large' /> : this.renderContributions()}
                    </div>
                </div>
            </div>
        );
    }

    public renderContributions() {
        const contributions = this.state.contributions;

        if (!contributions.length) {
            return (
                <div className='w-100 display-flex justify-content-center palette--bc-neutral-4 border-1 border-radius-1'>
                    <p className='m-0 py-5 palette--c-neutral-5'>
                        You have no pending contributions.
                    </p>
                </div>
            );
        }

        return (
            <div className='w-100'>
                <div className='m-2'>
                    <div className='row px-2'>
                        <h5 className='palette--c-neutral-5 text-uppercase col-6'>Type</h5>
                        <h5 className='palette--c-neutral-5 text-uppercase col-4'>Action</h5>
                        <h5 className='palette--c-neutral-5 text-uppercase col-4'>Status</h5>
                        <h5 className='palette--c-neutral-5 text-uppercase col-10'>Fields changed</h5>
                    </div>
                </div>
                <div className='m-2 palette--bc-neutral-4 border-1 border-radius-1'>
                    {contributions.map((item, index) => {
                        const classes = arrayToClass([
                            `palette--bgc-neutral-${index % 2 === 0 ? '1' : '3'}`,
                            'w-100 p-2',
                        ]);

                        return (
                            <div key={randomId()} className={classes}>
                                <div className='row display-flex align-items-center'>
                                    <div className='col-6'>
                                        <StatusMarker
                                            tColor='secondary-4'
                                            bgColor='secondary-1'
                                            text={get(item, 'entityType')}
                                            type='tag'
                                        />
                                    </div>
                                    <div className='col-4'>
                                        <span className='palette--c-neutral-6'>
                                            {get(item, 'action')}
                                        </span>
                                    </div>
                                    <div className='col-4'>
                                        <StatusMarker
                                            tColor='primary-4'
                                            bgColor='primary-1'
                                            text={get(item, 'status')}
                                            type='tag'
                                        />
                                    </div>
                                    <div className='col-10'>
                                        <span className='palette--c-neutral-5'>
                                            {(get(item, 'changes') || []).join(', ') || '—'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

export const MyPendingContributions: any = connect(
    mapStateProps,
    mapDispatchProps,
    null,
    { forwardRef: true }
)(LandingLayout(MyPendingContributionsComponent));
